import { TFunction } from "i18next";

import {
  useMatchedClaims,
  useMatchedSignalEventsOccurrences,
} from "shared/api/claims/hooks";
import { useMatchedClaims as useMatchedClaimsFromSignalEvents } from "shared/api/signalEvents/hooks";
import { EventTypeEnum, SortBy } from "shared/types";

import { RadioSelectOption } from "features/components/RadioGroup";

export const DEFAULT_CLAIMS_FIELDS = [
  "externalID",
  "laborCode",
  "VIN",
  "date",
  "vehicle.vehicleManufacturedAt",
  "mileage",
  "notesTechnician",
  "notesCustomer",
];

export const MAX_LIMIT = 25;

// Key format: "{viewingEventType}_{relatedEventType}"
export const MATCHED_EVENTS_HOOK_MATCHING: Record<
  string,
  | typeof useMatchedClaims
  | typeof useMatchedSignalEventsOccurrences
  | typeof useMatchedClaimsFromSignalEvents
> = {
  [`${EventTypeEnum.CLAIM}_${EventTypeEnum.CLAIM}`]: useMatchedClaims,
  [`${EventTypeEnum.CLAIM}_${EventTypeEnum.SIGNAL_EVENT}`]:
    useMatchedSignalEventsOccurrences,
  [`${EventTypeEnum.SIGNAL_EVENT}_${EventTypeEnum.CLAIM}`]:
    useMatchedClaimsFromSignalEvents,
};

export const DETAILS_RELATED_EVENTS_ID = "details-related-events";

export enum CountTypeEnum {
  EVENT_COUNT = "EVENT_COUNT",
  VEHICLE_COUNT = "VEHICLE_COUNT",
  FRC_IMPACT = "FRC_IMPACT",
}

export enum ChartDateFieldEnum {
  VEHICLE_MANUFACTURED_AT = "vehicleManufacturedAt",
  EVENT_DATE = "eventDate",
  ADVANCED_FILTERS_DATE = "advancedFiltersDate",
}

export const getCountTypeOptions = (
  t: TFunction,
  enableTableFRCImpact?: boolean
): RadioSelectOption[] => {
  const baseOptions: RadioSelectOption[] = [
    {
      id: CountTypeEnum.EVENT_COUNT,
      value: t("schema:dashboard.event_count"),
    },
    {
      id: CountTypeEnum.VEHICLE_COUNT,
      value: t("common:analytics.by_age.affected_vehicles_label"),
    },
  ];

  if (enableTableFRCImpact) {
    return [
      ...baseOptions,
      {
        id: CountTypeEnum.FRC_IMPACT,
        value: t("schema:dashboard.frc_impact"),
      },
    ];
  }

  return baseOptions;
};

export const INITIAL_SMART_GROUP_COUNT = 25;
export const ADDITIONAL_LOAD_COUNT = 10;

export const DEFAULT_SIGNAL_EVENTS_SORT: SortBy = { recordedAt: "desc" };
